import {
    OLD_ANDROID_ANNOUNCEMENT_DETAIL,
    OLD_ANDROID_ANNOUNCEMENT_MESSAGE,
} from 'mk/autogenerated/translations/miniapps.8884373fcfe077a049f2bca77cd98ebb'
import { analyticsStoreEvent } from 'mk2/actions';
import Comments from 'mk2/apps/blogs/containers/Comments/Comments';
import UserStrollersWidget from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget';
import { initialize } from 'mk2/apps/blogs/initialize';
import { getCommentsIds } from 'mk2/apps/blogs/reducers';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import PhoneVerificationModal from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal';
import { phoneVerificationModalShow } from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.actions';
import PrivacyReminder from 'mk2/containers/PrivacyReminder/PrivacyReminder';
import SiteMenu from 'mk2/containers/SiteMenu/SiteMenu';
import { hasBuggyPhotoUploadInput } from 'mk2/helpers/detects';
import { AppState } from 'mk2/reducers';
import { MenuSelection } from 'mk2/schemas';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Store } from 'redux';
// TODO: Rewrite to React/Redux way
import { Album } from '../../../js/apps/photoblog/photoblogApp/components/Album';

interface CommentsAppProps {
    postKey: string;
    count: number;
    counterParentElement: HTMLElement;
    store: Store<AppState>;
}

export class CommentsApp extends React.Component<CommentsAppProps> {
    private dispose: () => void;

    public componentDidMount() {
        const { postKey, counterParentElement } = this.props;
        if (counterParentElement) {
            const counter = counterParentElement.querySelector('.comment2-counter');
            if (counter) {
                this.dispose = this.props.store.subscribe(() => {
                    const count = getCommentsIds(this.props.store.getState(), postKey).length;
                    counter.innerHTML = count === 0 ? '' : `${count}`;
                });
            }
        }
    }

    public componentWillUnmount() {
        if (this.dispose) {
            this.dispose();
        }
    }

    public render() {
        return (
            <Comments {...this.props} />
        );
    }
}

const staticCommentsInstances = {};
export function mountComments(element: HTMLElement, key, counterParentElement) {
    if (staticCommentsInstances[key]) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(staticCommentsInstances[key]);
        delete staticCommentsInstances[key];
        return;
    }

    staticCommentsInstances[key] = element;
    initialize(element, (props) => (
        <CommentsApp
            {...props}
            postKey={key}
            count={counterParentElement.dataset.comment2Count ? parseFloat(counterParentElement.dataset.comment2Count) : 0}
            counterParentElement={counterParentElement}
        />
    ));
}

const staticUserStrollersInstances = {};
export function mountUserStrollers(element: HTMLElement, key, isAdmin, username, userId) {
    if (staticUserStrollersInstances[key]) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(staticUserStrollersInstances[key]);
        delete staticUserStrollersInstances[key];
        return;
    }

    staticUserStrollersInstances[key] = element;

    initialize(element, (props) => {
        // newProps created to avoid error of error TS2339 (property does not exist on value of type)
        const newProps = {
            ...props,
            postKey: key,
            isAdmin,
            username,
            userId,
        };
        return (
            <UserStrollersWidget
                {...newProps}
            />
        );
    });
}

const staticSiteMenuInstances = {};
export function mountSiteMenu(element: HTMLElement, key, currentUrl: string, menuSelection: MenuSelection, hydrate: boolean) {
    if (staticSiteMenuInstances[key]) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(staticSiteMenuInstances[key]);
        delete staticSiteMenuInstances[key];
        return;
    }

    staticSiteMenuInstances[key] = element;

    initialize(element, (props) => {
        return (
            <SiteMenu dummySticky mobileShowLogo currentUrl={currentUrl} fluxibleCompatibility menuSelection={menuSelection} showHeader isHeaderSticky={false} />
        );
    }, hydrate /* We are using SSR to render header */);
}

// privacy reminder app is used only for rendering reminder on login page, for other pages, privacy
// reminder is part of site menu
const staticPrivacyReminderInstances = {};
export function mountPrivacyReminder(element: HTMLElement, key, currentUrl: string) {
    if (staticPrivacyReminderInstances[key]) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(staticPrivacyReminderInstances[key]);
        delete staticPrivacyReminderInstances[key];
        return;
    }

    staticPrivacyReminderInstances[key] = element;

    initialize(element, (props) => {
        return (
            <PrivacyReminder fluxibleCompatibility currentUrl={currentUrl}  />
        );
    });
}

const staticAlbumInstances: {
    [key: string]: {
        element: HTMLElement;
        component: Album;
    };
} = {};
export function mountAlbum(element: HTMLElement, key, images, currentIndex, isAdmin, isAlbumPopup, imageId) {
    unmountAlbum(key);

    staticAlbumInstances[key] = { element, component: null };
    initialize(element, (props) => (
        <Album
            {...props}
            images={images}
            currentIndex={currentIndex}
            isAdmin={isAdmin}
            isAlbumPopup={isAlbumPopup}
            imageId={imageId}
            ref={(r) => staticAlbumInstances[key].component = r}
        />
    ));
}

export function unmountAlbum(key) {
    if (staticAlbumInstances[key] && staticAlbumInstances[key].component) {
        staticAlbumInstances[key].component.resetUrl();
        ReactDOM.unmountComponentAtNode(staticAlbumInstances[key].element);
        delete staticAlbumInstances[key];
    }
}

let phoneVerification: HTMLElement;
let phoneVerificationStore: any;
export function mountPhoneVerification(element: HTMLElement) {
    unmountPhoneVerification();

    phoneVerification = element;
    phoneVerificationStore = initialize(element, (props) => (
        <PhoneVerificationModal {...props} />
    ));
}

export function unmountPhoneVerification() {
    if (phoneVerification) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(phoneVerification);
        phoneVerification = null;
        phoneVerificationStore = null;
        return;
    }
}

export function openPhoneVerification() {
    if (phoneVerification && phoneVerificationStore) {
        phoneVerificationStore.dispatch(phoneVerificationModalShow('manual'));
    }
}

class TrackedAnnouncementBox extends React.Component<{ onStoreEvent(name: string); }> {

    public componentDidMount() {
        this.props.onStoreEvent('old_android_announcement');
    }

    public render() {
        return (
            <AnnouncementBox
                type={BoxType.Yellow}
                hasDetailMessage
                message={OLD_ANDROID_ANNOUNCEMENT_MESSAGE}
                detailMessage={OLD_ANDROID_ANNOUNCEMENT_DETAIL}
            />
        );
    }

}
const ConnectedTrackedAnnouncementBox = connect(null, { onStoreEvent: analyticsStoreEvent })(TrackedAnnouncementBox);

let oldAndroidAnnouncementBox: HTMLElement;
export function mountOldAndroidAnnouncementBox(element: HTMLElement) {
    if (!hasBuggyPhotoUploadInput(window.navigator.userAgent)) {
        return;
    }

    if (oldAndroidAnnouncementBox) {
        // Unmount current react app
        ReactDOM.unmountComponentAtNode(oldAndroidAnnouncementBox);
        oldAndroidAnnouncementBox = null;
        return;
    }

    oldAndroidAnnouncementBox = element;

    initialize(element, (props) => {
        return (
            <ConnectedTrackedAnnouncementBox />
        );
    });
}
